// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo[data-v-1f25fc28] {\n  padding: 1em;\n  text-align: center;\n}\n.logo img[data-v-1f25fc28] {\n  margin-bottom: 0.5em;\n  width: 120px;\n}\n@media (max-width: 576px) {\n.logo img[data-v-1f25fc28] {\n    width: 90px;\n}\n}\n.logo .sub-line[data-v-1f25fc28] {\n  font-size: 12px;\n  line-height: 1.5;\n  color: #444444;\n  margin: 5px 0px;\n}\n.logo .sub-line a[data-v-1f25fc28] {\n  color: #f24a58;\n}", ""]);
// Exports
module.exports = exports;
